const MODEL_NAME = 'multiCategory'
export default [
  {
    path: `/${MODEL_NAME}/index`,
    name: 'multiCategory',
    component: () =>
      import(/* webpackChunkName: "multi-category" */ '@pages/multiCategory/index.vue')
  }
]
